import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Navbar, Nav, NavDropdown, Form } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import tdLogo2 from '../images/TD Logo 2 Color.png';
import { Logout } from '../actions/LoginActions';
import { QuickSearch } from '../actions/SearchActions';
import { RequestNav, RequestNav2 } from '../actions/NavActions';

const AppHeader = (props) => {

  const dispatch = useDispatch();
  const userInfo = useSelector(state => state.userInfo.value);
  const loginInfo = useSelector(state => state.loginInfo.value);
  const navInfo = useSelector(state => state.navInfo.value);
  const navigate = useNavigate();
  const [userName, updateLoggedInUserName] = useState('');
  const [canUserWebUpload, updateCanUserWebUpload] = useState(false);
  const [quickSearchText, updateQuickSearchText] = useState('');
  const [isQuickSearching, updateIsQuickSearching] = useState(false);
  const [lastSearch, updateLastSearch] = useState('');

  useEffect(() => {

    if (loginInfo.loggedIn === true){
      updateLoggedInUserName(loginInfo.userName);
      // Guarded: permissions can be null or missing after a rejected login.
      updateCanUserWebUpload(loginInfo.permissions?.canWebUpload ?? false);
    }

  }, [userInfo, loginInfo]);

  const navToActiveDocuments = (e) => {
    console.log('nav to active Docs');
    let defaultPages = localStorage.getItem('DefaultParams');
    console.log(defaultPages);
    if (defaultPages === null) {


      var betaActiveDocuments = false;
       if (userInfo.loaded){
        if (userInfo !== undefined){
            betaActiveDocuments = toBoolean(userInfo.userSettings.betaActiveDocuments);
        }
       }

      if (betaActiveDocuments === true){
          if(navInfo.listener !== '') {
          RequestNav2('Beta Active Documents', '/BetaActiveDocuments', dispatch);
        } else {
          RequestNav('Beta Active Documents', 'activeDocumentsLink');
          //navigate('/ActiveDocuments', {replace: false});
        } 
      }
      else{
        if(navInfo.listener !== '') {
          RequestNav2('Active Documents', '/ActiveDocuments', dispatch);
        } else {
          RequestNav('Active Documents', 'activeDocumentsLink');
          //navigate('/ActiveDocuments', {replace: false});
        } 
      }
    } else {

      defaultPages = defaultPages = JSON.parse(
        localStorage.getItem('DefaultParams')
      );
      console.log(defaultPages);
      let adP = '';
      if (
        defaultPages.ActiveDocuments !== undefined &&
        defaultPages.ActiveDocuments.BP !== null &&
        defaultPages.ActiveDocuments.Step === null
      ) {
        adP = `?BP=${defaultPages.ActiveDocuments.BP}`;
      }
      if (
        defaultPages.ActiveDocuments !== undefined &&
        defaultPages.ActiveDocuments.BP !== null &&
        defaultPages.ActiveDocuments.Step !== null
      ) {
        adP = `?Step=${defaultPages.ActiveDocuments.Step}&BP=${defaultPages.ActiveDocuments.BP}`;
      }
      if (e.ctrlKey) {
        window.open('/ActiveDocuments' + adP, '_blank');
      } else {
        var betaActiveDocuments = false;
       if (userInfo.loaded){
        //let userSettings = loginInfo.userSettings;
        if (userInfo !== undefined){
            betaActiveDocuments = toBoolean(userInfo.userSettings.betaActiveDocuments);
        }
       }

      if (betaActiveDocuments === true){
          if(navInfo.listener !== '') {
          RequestNav2('Beta Active Documents', '/BetaActiveDocuments', dispatch);
        } else {
          RequestNav('Beta Active Documents', 'activeDocumentsLink');
          //navigate('/ActiveDocuments', {replace: false});
        } 
      }
      else{
        if(navInfo.listener !== '') {
          RequestNav2('Active Documents', '/ActiveDocuments', dispatch);
        } else {
          RequestNav('Active Documents', 'activeDocumentsLink');
          //navigate('/ActiveDocuments', {replace: false});
        } 
      }

      }
    }
  }

  function toBoolean(value) {
    if (typeof value === 'string') {
      return value.toLowerCase() === 'true';
    }
    return false;
  }

  const navToInbox = (e) => {
    console.log('navToInbox');
    let defaultPages = localStorage.getItem('DefaultParams');
    if (defaultPages === null) {
      RequestNav('Inbox', 'inboxLink');

    } else {
      defaultPages = defaultPages = JSON.parse(
        localStorage.getItem('DefaultParams')
      );
      let adP = '';

      if (e.ctrlKey) {
        window.open('/Inbox' + adP, '_blank');
      } else {
        //let path = '/Inbox' + adP;
        if(navInfo.listener !== '') {
          RequestNav2('Inbox', '/Inbox', dispatch);
        } else {
          RequestNav('Inbox', 'inboxLink');
        }
      }
    }
  }

  const navToWebUpload = (e) => {

      if (e.ctrlKey) {
        window.open('/WebUpload' + adP, '_blank');
      } else {
        //let path = '/Inbox' + adP;
        if(navInfo.listener !== '') {
          RequestNav2('Web Upload', '/WebUpload', dispatch);
        } else {
          RequestNav('Web Upload', 'webUpLink');
        }
      }
  }

  const navToSearch = (e) => {
  //navToSearch(e) {
    console.log('navToSearch');
    let defaultPages = localStorage.getItem('DefaultParams');
    if (defaultPages === null) {
      RequestNav('Search', 'searchLink');
      // this.setState({ adParams: '' }, () => {
      //   // let link = document.getElementById('inboxLink');
      //   // link.click();

      // });
    } else {
      defaultPages = defaultPages = JSON.parse(
        localStorage.getItem('DefaultParams')
      );
      let adP = '';

      if (e.ctrlKey) {
        window.open('/Search' + adP, '_blank');
      } else {
        //let path = '/Search' + adP;


          RequestNav('Search', 'searchLink');
          //   let link = document.getElementById('inboxLink');
          //   link.click();

      }
    }
  }

  const editQuickSearch = (e) => {
    updateQuickSearchText(e.target.value);
  }

  const onQSearchKeyDown = (e) => {
    if (e.code === 'Enter' || e.code === 'NumpadEnter') {
      e.preventDefault();
      if (quickSearchText.length > 0) {
        let srch = quickSearchText;
        updateIsQuickSearching(true);
        updateLastSearch(srch);
        QuickSearch(quickSearchText, quickSearchCallback, quickSearchNav);

      }
    }
  }

  const quickSearchCallback = (hasResults) => {
    console.log('callback');
    updateIsQuickSearching(false);
    console.log(userInfo.userSettings);
    let keepSearch = false;
    if(userInfo.userSettings.keepQuickSearch !== undefined)
    {
      if(hasResults && userInfo.userSettings.keepQuickSearch.toLowerCase() !== 'true')
      {
        updateQuickSearchText('');
      }
    }

  }

  const quickSearchNav = (site, path) => {
    console.log(`qnav ${site} ${path}`);
    if(navInfo.listener !== '') {
      RequestNav2(site, path, dispatch);
    } else {
      navigate(path, {replace: false});
    }

  }

  const LogoutTD = () => {
    Logout(dispatch);
  }


  // const updateSelectedDelegate = (delegate) => {

  //   if (delegate === loginInfo.userName){
  //     localStorage.setItem('delegate', loginInfo.userName);
  //     updateActiveUserName(loginInfo.userName);
  //   } else{
  //     localStorage.setItem('delegate', delegate.delegateUserName);
  //     updateActiveUserName(delegate.delegateUserName);
  //   }

  // }


    return (
      <Navbar collapseOnSelect expand='lg' variant='light' id='tdAppHeader'>

          <Navbar.Brand>
          <div className='td-navButton Light'>
            <img

              src={tdLogo2}

              height='30px'

              className='d-inline-block align-top'
              onClick={props.onToggle}
              style={{ cursor: 'pointer', maxHeight:'40px' }}
            />

              <i className='nav-icon fa-solid fa-caret-down'
                onClick={props.onToggle}
              />

          </div>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls='responsive-navbar-nav' />
        <Navbar.Collapse id='responsive-navbar-nav'>
          <Nav className='me-auto'>
            {/*<Nav.Link><i className='fa-solid fa-cogs' />{' '}System Manager</Nav.Link>*/}
          </Nav>
          <Nav>
          <Link
              id='searchLink'

              to={`/Search`}
              style={{ display: 'none' }}
            >
              Search
            </Link>
            <span
              className='nav-link nav-icon'
              style={{ cursor: 'pointer', marginLeft:'0px' }}
              title='Advanced Search'
              onClick={(e) => navToSearch(e)}
            >
              <i className='fa-solid fa-search' />
            </span>
            <Form className='d-flex td-search-bar'>
              <div className='td-qsearch-container'>
                <input
                  type='search'
                  placeholder='Quick Search'
                  id='tdqSearchTxt'
                  className='td-search-input'
                  aria-label='Quick Search'
                  size='sm'
                  value={quickSearchText}
                  onChange={editQuickSearch}
                  onKeyDown={onQSearchKeyDown}
                  autoComplete='off'
                />

                {isQuickSearching &&
                <i style={{position: 'absolute', right: '12px', top: '12px', color: '#111'}} className='fa-solid fa-spinner fa-spin' />
                }
              </div>
            </Form>

            <span
              className='nav-link'
              style={{ cursor: 'pointer' }}
              onClick={(e) => navToInbox(e)}
            >
              <i className='fa-solid fa-inbox' /> Inbox
            </span>

            <Link
              id='advancedSearch'
              className='nav-link'
              to={`/Search?Value=${lastSearch}`}
              style={{ display: 'none' }}
            ></Link>
            <span
              className='nav-link'
              style={{ cursor: 'pointer' }}
              onClick={(e) => navToActiveDocuments(e)}
            >
              <i className='fa-solid fa-cubes' /> Active Documents
            </span>
            <Link
              id='webUpLink'
              className='nav-link'
              to={`/WebUpload`}
              style={{ display: 'none' }}
            ></Link>
            {canUserWebUpload && (
              <span
                className='nav-link'
                style={{ cursor: 'pointer' }}
                onClick={(e) => navToWebUpload(e)}
              >
                <i className='fa-solid fa-upload' /> Web Upload
              </span>
            )}

            <NavDropdown
              title={
                <span>
                  <i className='fa-solid fa-question' /> Help
                </span>
              }
              align='end'
              id='helpMenu'
            >
              <div className='dropdown-item'>
                <a
                  className='app-link'
                  href='https://trindocs.atlassian.net/wiki/spaces/TDSupport/pages/916029447/TrinDocs+6+Quick+Tip+Videos'
                  target='_blank'
                  rel='noreferrer'
                >
                  <i className='fa-solid fa-film' /> TrinDocs University
                  YouTube Channel
                </a>
              </div>

              <NavDropdown.Divider />

              <div className='dropdown-item'>
                <a
                  className='app-link'
                  href='https://trindocs.atlassian.net/wiki/spaces/TDSupport/pages/909213697/TrinDocs+6+How-To+and+Support+Articles'
                  target='_blank'
                  rel='noreferrer'
                >
                  <i className='fa-solid fa-book' /> Training
                  documentation
                </a>
              </div>

              <NavDropdown.Divider />

              <div className='dropdown-item'>
                <a
                  className='app-link'
                  href='https://trindocs.atlassian.net/wiki/spaces/TDSupport/pages/798785537/TrinDocs+Webinars'
                  target='_blank'
                  rel='noreferrer'
                >
                  <i className='fa-solid fa-video' /> Webinars
                </a>
              </div>

              <NavDropdown.Divider />

              <div className='dropdown-item'>
                <a
                  className='app-link'
                  href='https://trindocs.atlassian.net/wiki/spaces/TDSupport/overview'
                  target='_blank'
                  rel='noreferrer'
                >
                  <i className='fa-solid fa-info-circle' /> Support Policy
                </a>
              </div>

              <NavDropdown.Divider />

              <div className='dropdown-item'>
                <a
                  className='app-link'
                  href='https://trindocs.atlassian.net/wiki/spaces/TDSupport/pages/753664197/TrinDocs+Newsletters'
                  target='_blank'
                  rel='noreferrer'
                >
                  <i className='fa-solid fa-calendar' /> Monthly
                  Newsletters
                </a>
              </div>

              <NavDropdown.Divider />

              <div className='dropdown-item'>
                <i className='fa-solid fa-headset' /> Contact Us:{' '}
                <a href='mailto: support@trindocs.com'>support@trindocs.com</a>
              </div>
            </NavDropdown>

            <NavDropdown
              title={
                <span>
                  <i className='fa-solid fa-user' /> {userName}
                </span>
              }
              align='end'
              id='userMenu'
            >
              {/*<NavDropdown.Item href='/UserProfile'>*/}
              <Link className='dropdown-item app-link' to='/UserProfile'>
                <i className='fa-solid fa-user' /> User Profile
              </Link>
              {/*</NavDropdown.Item>*/}
              <NavDropdown.Divider />
              <Link className='dropdown-item app-link' to='/DocUploadHist'>
                <i className='fa-solid fa-table' /> Document Upload
                History
              </Link>

              <NavDropdown.Divider />
              <NavDropdown.Item onClick={props.toggleAboutTrinDocs}>
                <i className='fa-regular fa-circle-info' /> About TrinDocs
              </NavDropdown.Item>

              <NavDropdown.Divider />
              <NavDropdown.Item onClick={LogoutTD}>
                <i className='fa-solid fa-sign-out-alt' /> Logout
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
          <Link id='logOutLink' to={'/'} style={{ display: 'none' }}>
            HiddenLink
          </Link>
          {toBoolean(userInfo.userSettings.betaActiveDocuments) === true && (
           <Link
              id='activeDocumentsLink'
              to={'/BetaActiveDocuments'}
              style={{ display: 'none' }}
            >
              HiddenLink
            </Link>
          )}
          {toBoolean(userInfo.userSettings.betaActiveDocuments) !== true && (
           <Link
              id='activeDocumentsLink'
              to={'/ActiveDocuments'}
              style={{ display: 'none' }}
            >
              HiddenLink
            </Link>
          )}
            <Link
              id='inboxLink'
              to={'/Inbox'}
              style={{ display: 'none' }}
            >
              HiddenLink
            </Link>
        </Navbar.Collapse>
      </Navbar>
    );
  }


export default AppHeader;
